<script setup lang="ts">
  import { MpIcon, MpText } from '@borg/ui';

  const props = defineProps<{
    icon: InstanceType<typeof MpIcon>['$props']['name'];
    text?: string;
    fallback: string;
  }>();

  const content = computed(() =>
    props.text && props.text.length > 0 ? props.text : props.fallback,
  );
</script>

<template>
  <span class="icon-info">
    <SiteIcon
      :icon="icon"
      size="sm"
    />
    <MpText
      :class="{
        'icon-info__text': true,
        'icon-info__text--fallback': !text,
      }"
      :shade="text ? undefined : '30'"
      no-margin
    >
      {{ content }}
    </MpText>
  </span>
</template>

<style scoped lang="scss">
  .icon-info {
    display: flex;
    align-items: center;
    gap: var(--mp-space-20);
    margin-right: var(--mp-space-70);

    &__text {
      &--fallback {
        font-style: italic;
      }
    }
  }
</style>
